/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-07-06 18:08:10
 * @FilePath: \sns-user-frontend\src\utils\xssFilter.js
 * @Description: 
 */
import xss from 'xss'

// 过滤名单外的标签属性
const defaultWhiteList = {
  "div": ["style", "data-hiddenline", "contenteditable"],
  "span": ["style"],
  "strong": ["style"],
  "p": ["style", 'data-media-value'],
  "i": ["style"],
  "u": ["style"],
  "em": ["style"],
  "br": ["style"],
  "ul": ["style"],
  "ol": ["style", "start"],
  "li": ["style", "data-index"],
  "a": ["style", "href", "rel", "target", 'data-type', 'data-value', 'data-at'],
  "img": ["style", "src", 'data-type', 'data-value', 'data-w', 'data-h', 'data-reduce', 'data-src'],
  "video": ["style", "src", "controls", "muted", "controlslist", "poster", 'data-type', 'data-value', 'data-src'],
  "iframe": ["style", "src", "frameborder", "allowfullscreen", "data-value"],
  "b": ["class", "style"],
  "sup": [],
  "hr": []
}

// 防止异常样式阻塞页面
const cssDefaultWhiteList = {
  whiteList: {
    top: false,
    font: true,
    color: true,
    left: false,
    right: false,
    width: false,
    height: false,
    bottom: false,
    position: false,
    'font-size': true,
    'font-style': true,
    'background': true,
    'text-align': true,
    'font-weight': true,
    'text-indent': true,
    'line-height': true,
    'text-decoration': true,
    'background-color': true,
    'text-decoration-line': true,
    'text-decoration-style': true,
    'text-decoration-color': true
  }
}

export default function (html, whiteList, cssWhiteList) {
  return xss(html, {
    "stripIgnoreTag": true,
    "whiteList": whiteList || defaultWhiteList,
    "css": cssWhiteList ? cssWhiteList : cssDefaultWhiteList,
  })
}

